export const FontSizeType = {
  Large: 'large',
  Medium: 'medium',
  Small: 'small'
};
